import * as constState from './constants';
import * as icons from '../../core/icons';
import { changeLogs, scopes } from '../../core/enums';

const getLogs = selectedLogs => {
    if (selectedLogs.length === 0) return changeLogs;

    return changeLogs.filter(changeLog =>
        selectedLogs.includes(changeLog.value)
    );
};

const getScopes = selectedScopes => {
    if (selectedScopes.length === 0) return scopes;

    return scopes.filter(scope => selectedScopes.includes(scope.value));
};

const ejercicio = new Date().getFullYear();

const initialEntities = {
    [constState.ENTITY_USUARIO]: {
        entity: constState.ENTITY_USUARIO,
        title: 'Usuarios',
        id: 'id',
        resume: 'nombre',
        api: 'usuarios/',
        icon: icons.UsuariosIcon,
        message: () => alert(constState.ENTITY_USUARIO)
    },
    [constState.ENTITY_CONTACTO]: {
        entity: constState.ENTITY_CONTACTO,
        title: 'Contactos',
        id: 'id',
        resume: 'nombre',
        api: 'contactos/',
        icon: icons.ContactIcon,
        //scopes: getScopes([]),
        //changeLogs: getLogs([]),
        message: () => alert(constState.ENTITY_CONTACTO)
    },
    [constState.ENTITY_SUBCUENTA]: {
        entity: constState.ENTITY_SUBCUENTA,
        title: 'Cuentas',
        id: 'id',
        resume: 'descripcion',
        api: 'subcuentas/',
        icon: icons.CuentasIcon,
        //scopes: getScopes([]),
        //changeLogs: getLogs([]),
        message: () => alert(constState.ENTITY_SUBCUENTA)
    },
    [constState.PROVEEDORES]: {
        entity: constState.PROVEEDORES,
        title: 'Proveedores',
        id: 'id',
        resume: 'nombre',
        api: 'proveedores/',
        icon: icons.ProveedoresIcon,
        message: () => alert('Este es el Proveedor')
    },
    [constState.ENTITY_CLIENTE]: {
        entity: constState.ENTITY_CLIENTE,
        title: 'Clientes',
        id: 'id',
        resume: 'nombre',
        api: 'clientes/',
        icon: icons.ClientesIcon,
        message: () => alert('Este es el Cliente')
    },
    [constState.BANCOS]: {
        entity: constState.BANCOS,
        title: 'Bancos',
        id: 'id',
        resume: 'nombre',
        api: 'bancos/',
        icon: icons.BancosIcon,
        message: () => alert('Este es el Banco')
    },
    [constState.VENCIMIENTOS]: {
        entity: constState.VENCIMIENTOS,
        title: 'Vencimientos',
        id: 'id',
        resume: 'nombre',
        api: 'vencimientos/',
        icon: icons.VencimientosIcon,
        message: () => alert('Este es el Vencimiento')
    },
    [constState.DIARIO]: {
        entity: constState.DIARIO,
        title: 'Diario/Mayor',
        id: 'asiento',
        resume: 'concepto',
        api: 'contabilidad/diario/',
        icon: icons.DiarioIcon,
        message: () => alert('Este es el Diario')
    },
    [constState.FORMASPAGO]: {
        entity: constState.FORMASPAGO,
        title: 'Formas de Pago',
        id: 'id',
        resume: 'descripcion',
        api: 'formaspago/',
        icon: icons.FormasPagoIcon,
        message: () => alert('Este es la Forma de Pago')
    },

    [constState.PARTIDAS_PRESUPUESTO]: {
        entity: constState.PARTIDAS_PRESUPUESTO,
        title: 'Conceptos Presupuesto',
        id: 'id',
        resume: 'descripcion',
        api: 'partidaspresupuesto/',
        icon: icons.PartidasPresupuestoIcon,
        message: () => alert('Este es una partida del presupuesto')
    },
    [constState.PRESUPUESTO_CONTABLE]: {
        entity: constState.PRESUPUESTO_CONTABLE,
        title: 'Presupuesto Contable',
        id: 'ejercicio',
        resume: 'descripcion',
        api: 'presupuestocontable/',
        icon: icons.PresupuestoContableIcon,
        message: () => alert('Este es un presupuesto contable')
    },
    [constState.GASTOS]: {
        entity: constState.GASTOS,
        title: 'Gastos',
        id: 'id',
        resume: 'concepto',
        api: 'gastos/',
        icon: icons.GastosIcon,
        message: () => alert('Este es un gasto')
    },
    [constState.ENTITY_FACTURAS]: {
        entity: constState.ENTITY_FACTURAS,
        title: 'Facturas',
        id: 'id',
        resume: 'concepto',
        api: 'ventas/facturas/',
        icon: icons.FacturasIcon,
        message: () => alert('Este es una factura')
    },
    [constState.TAREAS]: {
        entity: constState.TAREAS,
        title: 'Tareas',
        id: 'id',
        resume: 'codigo',
        api: 'tareas/',
        icon: icons.TareasIcon,
        message: () => alert('Este es la tarea')
    },
    [constState.MOVIMIENTOS_TESORERIA]: {
        entity: constState.MOVIMIENTOS_TESORERIA,
        title: 'Movimientos Tesorería',
        id: 'id',
        resume: 'concepto',
        api: 'tesoreria/movimientos/',
        icon: icons.CobrosPagosIcon,
        message: () => alert('Este es un moviento de tesoreria')
    },
    [constState.IMPUESTO_347_PROVEEDORES]: {
        entity: constState.IMPUESTO_347_PROVEEDORES,
        title: 'Modelo 347 Proveedores',
        id: 'asiento',
        resume: 'concepto',
        api: `contabilidad/declaraciones/m347?tipo=proveedores&ejercicio=${ejercicio - 1}`,
        icon: icons.TaxIcon,
        message: () => alert('Este es el Modelo 347 de Proveedores')
    },
    [constState.IMPUESTO_347_CLIENTES]: {
        entity: constState.IMPUESTO_347_CLIENTES,
        title: 'Modelo 347 Clientes',
        id: 'asiento',
        resume: 'concepto',
        api: `contabilidad/declaraciones/m347?tipo=clientes&ejercicio=${ejercicio - 1}`,
        icon: icons.TaxIcon,
        message: () => alert('Este es el Modelo 347 de Clientes')
    }
};

export default initialEntities;
